module.exports = __webpack_public_path__ + "static/media/ticket_campaign_icon.5ec57c46.png";